import i18n from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'

// have to import the json and then make it a const to have type safety
import defaultTranslation from './locales/dev/translation.json'
const defaultResource = { ...{ translation: defaultTranslation } } as const

i18n
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string) =>
      import(`./locales/${language}/translation.json`).then(
        (module) => module.default
      )
    )
  )
  .init({
    debug: false,
    lng: 'dev',
    fallbackLng: 'dev',
    interpolation: { escapeValue: false },
    lowerCaseLng: true,
    load: 'currentOnly',
  })

export default i18n
